export const VIEWS = {
  WELCOME: 'WELCOME',
  CALL: 'CALL'
} as const
